import { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import { BackendLink } from '../../../Components';
import './ServiceRightSide.css';

const ServiceRightSide = () => {
    const [randomServices, setRandomServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const response = await fetch(`${BackendLink}/AllServices/`);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();

                const shuffledServices = [...data].sort(() => 0.5 - Math.random());
                const selectedServices = shuffledServices.slice(0, 3);
                setRandomServices(selectedServices);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchServices();
    }, []);

    return (
    <div>
        <h4 className="serRightMainTitle" data-aos="fade-up">
            Some of our Services
        </h4>

        <div className="ServiceRightSide">
        {(loading || error || randomServices.length === 0)
            ? Array.from({ length: 3 }).map((_, i) => (
                <div className="rightSide-skelton-service-card" key={i}>
                <Skeleton 
                className='rightServiceImg-skelton'
                height={150} 
                baseColor="var(--bg-footer)" 
                highlightColor="var(--bg-body)" 
                />
                <Skeleton 
                className='rightServiceTxt-skelton'
                height={10} 
                baseColor="var(--bg-footer)" 
                highlightColor="var(--bg-body)" 
                />
                </div>  
            ))
            : randomServices.map(({ id, bgImg, txt }, index) => (
                <Link
                to={`/Services/${id}`}
                key={id}
                className="service-card"
                data-aos="fade-up"
                data-aos-delay={`${index}00`}
                >
                <div className="rightServiceImg-wrapper">
                    <img src={bgImg} alt={txt} className="service-image" />
                </div>
                <h3 className="rightSideSerTitle">{txt}</h3>
                </Link>
            ))
        }
        </div>

    </div>
    );
};

export default ServiceRightSide;
